import React from "react";
import {
  Container,
  Row,
  Col,
  Navbar,
  Nav,
  Button,
  Card,
  Badge,
  ListGroup,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaCheckCircle } from "react-icons/fa";

import "./WashAndPress.css"; // Custom styles
import { useNavigate } from "react-router-dom";

const images3435 = "/images/home/pohp.jpg";

const WashAndPressBootstrap = () => {
  const navigate = useNavigate();

  const precisionFeatures = [
    {
      title: "Fabric-specific wash and dry programs",
      desc: "No shrinkage, no colour loss, no fibre damage",
      icon: "👕",
    },
    {
      title: "Automated chemical dosing systems",
      desc: "Perfect chemistry on every load — no guesswork",
      icon: "🧪",
    },
    {
      title: "Pre-treatment on collars, cuffs & underarms",
      desc: "Brightest, cleanest results on your most visible areas",
      icon: "🧼",
    },
    {
      title: "pH-balanced professional detergents",
      desc: "Clothes that look newer, wash after wash",
      icon: "💧",
    },
    {
      title: "Steam pressing after washing",
      desc: "Crisp, sharp finish on a truly clean garment",
      icon: "💨",
    },
    // { title: "QR code traceability", desc: "Full transparency of your garment's journey through our care facility from pickup to drop-off.", icon: "📱" }
  ];

  const whatsIncluded = [
    {
      title: "Pre-wash inspection",
      desc: "Detailed logging of stains and loose threads.",
      icon: "📋",
    },
    {
      title: "Fabric-specific sorting",
      desc: "Separate loads for weight, color, and fiber.",
      icon: "🧺",
    },
    {
      title: "Premium detergents",
      desc: "Hypoallergenic and eco-certified agents.",
      icon: "🌿",
    },
    {
      title: "Temperature control",
      desc: "Strict heat limits to protect delicate elastic.",
      icon: "🌡️",
    },
    {
      title: "Collar/Cuff pre-treatment",
      desc: "Targeted removal of oils and perspiration.",
      icon: "👔",
    },
    {
      title: "Color-safe brightening",
      desc: "Restoring whites without harsh bleaches.",
      icon: "✨",
    },
    {
      title: "Controlled drying",
      desc: "Cool-down cycles to prevent setting creases.",
      icon: "🌬️",
    },
    {
      title: "Button/Bead checks",
      desc: "Reinforcement or protection during processing.",
      icon: "🔘",
    },
    {
      title: "Biodegradable covers",
      desc: "Sustainable protection for delivery.",
      icon: "🌍",
    },
  ];

  return (
    <div className="wash-and-press-app mt-4">
      <section className="hero-section-wash-fold mt-5">
        <div className="hero-overlay-wash-fold mt-5">
          <Container fluid="xl" className="py-5 mt-4 h-100">
            <Row className="align-items-center justify-content-center text-center h-100 mt-5">
              <Col lg={8}>
                <h1 className="hero-title mb-4">
                  Wash & Fold Effortlessly Fresh.Neatly Returned
                  {/* <span className="hero-highlight-wash-fold">
                    
                  </span>{" "} */}
                  <br />
                </h1>

                <div className="d-flex justify-content-center flex-wrap gap-3 mt-4">
                  <button className="suhedule-btn-dark"
                   onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }>
                    BOOK NOW
                  </button>

                  <button
                    className="view-prices-list"
                    onClick={() => navigate("/laundry-price")}
                  >
                    VIEW PRICE LIST
                  </button>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>

      <section className="hero-section pt-5 mt-1 bg-light-gray">
        <Container fluid="xl" className="py-5 mt-4">
          <Row className="align-items-center g-5 px-3">
            <Col lg={6}>
              <p
                className="lead text-muted mb-5"
                style={{ textAlign: "justify" }}
              >
                Your everyday laundry, handled with the same care we give
                everything else. Life in the UAE moves fast. Wash & Fold is
                designed for the families and professionals who want their
                regular laundry handled efficiently without sacrificing quality.
                Clean, fresh, and folded to a best standard — returned to you
                ready to go straight into the wardrobe.
              </p>
              <i>
                “Fill the Fresh N Clean white Bag with up to 12 kg of laundry
                for just AED 60.
              </i>
              <div className="d-flex flex-wrap gap-3"></div>
            </Col>
            <Col lg={6} className="text-center">
              <div className="circle-ring" data-aos="fade-down">
                <img src={images3435} alt="Model" />
              </div>{" "}
            </Col>
          </Row>
        </Container>
      </section>

      {/* Precision Engineering Grid */}
      <section className="py-5 bg-white">
        <Container fluid="xl" className="py-5">
          <div className="text-center mb-5">
            <h2 className="expertise-title">
              Precision Engineering for Every Thread
            </h2>
            <div className="title-accent bg-primary-main mx-auto mt-3"></div>
          </div>
          <Row className="g-4">
            {precisionFeatures.map((feature, idx) => (
              <Col key={idx} md={6} lg={4}>
                <Card className="precision-card h-100 border-0 bg-light p-4">
                  <Card.Body>
                    <div className="fs-1 mb-3">{feature.icon}</div>
                    <h4 className="fw-bold mb-3">{feature.title}</h4>
                    <Card.Text className="text-muted">{feature.desc}</Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Philosophy / Not a Conveyor Belt */}
      <section className="py-5 bg-light-gray border-top border-bottom">
        <Container fluid="xl" className="py-5">
          <Row className="align-items-center g-5">
            <Col lg={6}>
              <h2 className="expertise-title">Not a "Conveyor-Belt Laundry"</h2>
              <p className="text-muted fs-5 lh-lg mb-4">
                At Fresh N Clean, we reject the industrial approach to mass
                laundering. Every garment undergoes an individual assessment by
                our textile specialists to determine the optimal cleaning
                profile.
              </p>
              <p className="text-muted fs-5 lh-lg mb-4">
                We utilize premium chemicals and softened water systems to
                ensure that your favorites are not just cleaned, but preserved
                for years of wear.
              </p>
              <div className="d-flex gap-4 mt-4">
                <div className="border-start border-primary-main border-4 ps-3">
                  <span className="d-block fw-bold small text-uppercase">
                    Water Quality
                  </span>
                  <span className="text-muted small">
                    Triple-filtered soft water
                  </span>
                </div>
                <div className="border-start border-primary-main border-4 ps-3">
                  <span className="d-block fw-bold small text-uppercase">
                    Assessment
                  </span>
                  <span className="text-muted small">
                    Manual fiber inspection
                  </span>
                </div>
              </div>
            </Col>
            <Col lg={6}>
              <img
                src="https://images.unsplash.com/photo-1517677208171-0bc6725a3e60?auto=format&fit=crop&q=80&w=800"
                alt="Washing Detail"
                className="img-fluid rounded-4 shadow"
              />
            </Col>
          </Row>
        </Container>
      </section>

      {/* What's Included Checklist */}
      <section className="py-5 bg-white expertise-section">
        <Container fluid="xl" className="py-5">
          {/* Heading */}
          <div className="mb-5 text-center">
            <h2 className="expertise-title fade-up">
              The Archival Standard of Care
            </h2>
            <p className="text-muted fade-up delay-1">
              Our comprehensive checklist ensures no detail is overlooked. Every
              item is treated as a unique investment.
            </p>
          </div>

          {/* Grid */}
          <Row className="g-4">
            {whatsIncluded.map((item, idx) => (
              <Col key={idx} md={6} lg={4}>
                <div className="expertise-card-wash-fold fade-up">
                  <div className="icon-box">{item.icon}</div>

                  <div>
                    <h5 className="fw-bold mb-2">{item.title}</h5>
                    <p className="text-muted small m-0">{item.desc}</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Ideal For Section */}
      <section className="py-2 bg-light-gray">
        <Container fluid="xl" className="py-5">
          <div className="mb-5">
            <h2 className="expertise-title">Designed For Excellence</h2>
            <p className="text-muted">
              Curated care for your most frequent essentials.
            </p>
          </div>
          <Row className="g-3">
            {[
              {
                name: "Business Shirts",
                img: "https://i.etsystatic.com/42438419/r/il/b94333/5095695152/il_fullxfull.5095695152_arx7.jpg",
              },
              {
                name: "Abayas & Kandoras",
                img: "https://images.unsplash.com/photo-1583337130417-3346a1be7dee?auto=format&fit=crop&q=80&w=600",
              },
              {
                name: "Linen Shirts",
                img: "https://stylecaster.com/wp-content/uploads/2023/05/Bloomingdales-Linen-Chambray-Shirt.jpg?resize=600",
              },
              {
                name: "Polo Shirts",
                img: "https://images.unsplash.com/photo-1586363104862-3a5e2ab60d99?auto=format&fit=crop&q=80&w=600",
              },
            ].map((item, idx) => (
              <Col key={idx} md={3}>
                <div className="category-card position-relative overflow-hidden rounded-3 shadow-sm border">
                  <img
                    src={item.img}
                    alt={item.name}
                    className="img-fluid w-100 h-100 object-fit-cover"
                  />
                  <div className="card-overlay position-absolute bottom-0 w-100 p-3 text-white">
                    <h6 className="fw-bold m-0">{item.name}</h6>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
          <div className="d-flex justify-content-center flex-wrap gap-2 mt-4">
            {["Gatra & Sheilas", "School Uniforms", "Household Linens"].map(
              (tag, i) => (
                <Badge
                  key={i}
                  bg="primary-tint"
                  text="primary-main"
                  className="px-3 py-2 fw-normal"
                >
                  {tag}
                </Badge>
              ),
            )}
          </div>
        </Container>
      </section>

      {/* CTA Banner */}
      <section className="py-3 bg-white wash-section">
        <Container fluid="xl" className="my-5">
          {/* CTA */}

          {/* INCLUDED SECTION */}
          <div className="included-box">
            <h4 className="expertise-title fade-up">What's Included</h4>

            <Row className="g-4 mt-3">
              {[
                "Pre-wash inspection for stains, loose buttons, open seams, and fabric vulnerabilities",
                "Fabric-specific sorting: cottons, synthetics, silks, and delicates laundered in separate cycles",
                "Premium, pH-balanced detergents with no harsh bleaching agents",
                "Temperature-controlled wash cycles adjusted per fabric care label requirements",
                "Pre-treatment of collar lines, cuffs, and underarm areas before the main wash",
                "Colour-safe brightening treatment for whites and light-coloured garments",
                "Controlled tumble or air drying based on fabric type to prevent shrinkage",
                "Full professional steam pressing as outlined in our Press Only service",
                "Button and bead integrity check post-wash before pressing",
                "Collar stays reinserted and collar bones re-shaped on dress shirts",
                "QR code traceability throughout every stage of wash and press",
                "Returned on hangers in Biodegradable garment covers",
              ].map((item, index) => (
                <Col md={6} lg={4} key={index}>
                  <div className="feature-card fade-up">
                    <div className="icon">
                      <FaCheckCircle />
                    </div>
                    <p>{item}</p>
                  </div>
                </Col>
              ))}
            </Row>
          </div>

          <br />

          <div className="cta-banner-dark text-center text-white mb-5 mt-5">
            <h2 className="display-6 fw-bold mb-3 fade-up text-center mt-5 text-light">
              Experience the difference a professional wash makes.
            </h2>

            <p className="text-white-50 fs-5 mb-4 fade-up delay-1">
              Your garments deserve better than a standard wash. Elevate your
              everyday.
            </p>

            <div className="cta-btns fade-up delay-2">
              <button className="btn-downlod-app">DOWNLOAD APP</button>
              <button className="btn-whatssp-down"  onClick={() =>
    window.open(
      "https://api.whatsapp.com/send?phone=971545718455&text=Hi,%20I%20would%20like%20to%20book%20a%20laundry%20pickup.",
      "_blank"
    )
  }
                  >WHATSAPP US</button>
            </div>
          </div>
        </Container>
      </section>

      {/* Footer */}
    </div>
  );
};

export default WashAndPressBootstrap;
